// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7x-0";
export var startPickingButton = "_7x-1";